import { BasiqTransactionStatus } from "@bitwarden/web-vault/app/models/types/basiq.types";

export enum TransactionType {
  Charge = 0,
  Credit = 1,
  PromotionalCredit = 2,
  ReferralCredit = 3,
  Refund = 4,
}

export enum TransactionStatusEnum {
  opening = "opening",
  transaction = "transaction",
  alignment = "alignment",
  starting_alignment = "starting_alignment",
  fake = "fake",
  closing = "closing",
  pending = "pending",
  manual_balance = "manual_balance",
  empty_account_balance = "empty_account_balance",
}

export enum AmountTypeEnum {
  regular = "regular",
  reverse = "reverse",
}

/** Synthetic balance rows (opening/closing/manual/alignment/empty/fake) - never real user
    activity, and never valid transfer/conversion link candidates. Single source of truth,
    shared by search filtering, monthly-summary aggregation, and transfer-link detection. */
export const BALANCE_DEFINITIONS: ReadonlySet<TransactionStatusEnum> = new Set([
  TransactionStatusEnum.alignment,
  TransactionStatusEnum.starting_alignment,
  TransactionStatusEnum.manual_balance,
  TransactionStatusEnum.opening,
  TransactionStatusEnum.closing,
  TransactionStatusEnum.empty_account_balance,
  TransactionStatusEnum.fake,
]);
